import { Badge } from '@/components/ui/badge'
import Price from '@/components/money/price'

const Discount = ({ minPrice, maxPrice }: { minPrice: number; maxPrice: number }) => {
  return (
    <Badge variant="default">
      –<Price price={maxPrice - minPrice} /> / noc
    </Badge>
  )
}

export default Discount
